/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setLocalePreference} from '../api'

export const useMutationSetLocalePreference = createReactQueryMutationHook('setLocalePreference', setLocalePreference)
